module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"8\" viewBox=\"0 0 15 8\">\n  <polyline fill=\"none\" stroke=\"#000\" points=\"0 0 6.472 7.583 13 0\" transform=\"translate(1)\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/SelectControl/selectIcon.svg
// module id = 884
// module chunks = 168707334958949